import React, { useState } from 'react';

const PatientConstantes = ({ constantes, setConstantes, isRecording }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const constantes_config = [
    { key: 'temperature', title: 'Temperature', placeholder: 'E.g. 37.2', unit: '°C' },
    { key: 'tension', title: 'Blood pressure', placeholder: 'E.g. 120/80', unit: 'mmHg' },
    { key: 'frequenceCardiaque', title: 'Heart rate', placeholder: 'E.g. 72', unit: 'bpm' },
    { key: 'saturation', title: 'O2 saturation', placeholder: 'E.g. 98', unit: '%' },
    { key: 'glycemie', title: 'Blood glucose', placeholder: 'E.g. 1.2', unit: 'g/L' },
    { key: 'poids', title: 'Weight', placeholder: 'E.g. 70', unit: 'kg' },
    { key: 'taille', title: 'Height', placeholder: 'E.g. 175', unit: 'cm' }
  ];

  // Generate preview string for constantes
  const generatePreviewString = () => {
    const parts = [];

    constantes_config.forEach(config => {
      const value = constantes[config.key];
      if (value && value.trim()) {
        parts.push(`${config.title}: ${value} ${config.unit}`);
      }
    });

    return parts.length > 0 ? parts.join(' • ') : 'No vital signs entered';
  };

  const updateConstante = (key, value) => {
    setConstantes(prev => ({
      ...prev,
      [key]: value
    }));
  };

  return (
    <div className="patient-constantes-panel" style={{ marginTop: '24px' }}>
      <div style={{
        padding: '24px',
        background: 'white',
        borderRadius: '12px',
        border: '1px solid #e5e7eb'
      }}>
        {/* Header with toggle */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '20px',
          cursor: 'pointer'
        }}
        onClick={() => setIsExpanded(!isExpanded)}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{
              width: '32px',
              height: '32px',
              background: '#ecfdf5',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '12px'
            }}>
              <span style={{ fontSize: '16px' }}>🩺</span>
            </div>
            <h3 style={{
              color: '#111827',
              margin: 0,
              fontSize: '18px',
              fontWeight: '600'
            }}>
              Patient vital signs
            </h3>
          </div>
          <div style={{
            background: '#f9fafb',
            color: '#6b7280',
            borderRadius: '20px',
            padding: '4px 12px',
            fontSize: '12px',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            border: '1px solid #e5e7eb'
          }}>
            <span>{isExpanded ? 'Collapse' : 'Enter'}</span>
            <span style={{ fontSize: '10px' }}>{isExpanded ? '▲' : '▼'}</span>
          </div>
        </div>

        {/* Preview Mode */}
        {!isExpanded && (
          <div style={{
            background: '#f9fafb',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            padding: '16px',
            fontSize: '14px',
            color: '#374151',
            lineHeight: '1.6'
          }}>
            {generatePreviewString()}
          </div>
        )}

        {/* Edit Mode */}
        {isExpanded && (
          <>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: '16px'
            }}>
              {constantes_config.map((constante) => (
                <div key={constante.key} style={{
                  background: '#ffffff',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  padding: '12px',
                  position: 'relative'
                }}>
                  <label style={{
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: '500',
                    color: '#6b7280',
                    marginBottom: '4px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}>
                    {constante.title}
                  </label>
                  <div style={{ position: 'relative' }}>
                    <input
                      type="text"
                      value={constantes[constante.key] || ''}
                      onChange={(e) => updateConstante(constante.key, e.target.value)}
                      placeholder={constante.placeholder}
                      disabled={false}
                      style={{
                        width: '100%',
                        padding: '8px 32px 8px 8px',
                        border: '1px solid #d1d5db',
                        borderRadius: '6px',
                        fontSize: '14px',
                        color: '#374151',
                        background: '#ffffff',
                        outline: 'none',
                        transition: 'all 0.2s',
                        boxSizing: 'border-box'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#059669';
                        e.target.style.boxShadow = '0 0 0 3px rgba(5, 150, 105, 0.1)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = '#d1d5db';
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                    <span style={{
                      position: 'absolute',
                      right: '8px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      fontSize: '12px',
                      color: '#9ca3af',
                      fontWeight: '500'
                    }}>
                      {constante.unit}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            <div style={{
              marginTop: '16px',
              padding: '12px',
              background: '#f9fafb',
              borderRadius: '8px',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ fontSize: '16px', marginRight: '8px' }}>💡</span>
                <span style={{ fontSize: '13px', color: '#6b7280', fontWeight: '500' }}>
                  Enter vital signs in real time during the consultation. They will be automatically included in the final report.
                </span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PatientConstantes;